module.exports = __webpack_public_path__ + "assets/travel_tracker_white.98231737.svg";